module.exports = __webpack_public_path__ + "img/20190622142245微信截图_20190622142645.772c1ead.png";